import type { AdvanceFilter } from '@/_containers';

import { InvoiceBatchCustomFilterWithRadios } from './invoice-batch-custom-filter-with-radios';

import type { InvoiceBatchFilterSchema } from '../../shared/filters';

export function invoiceBatchFilterRenderer(
  f: AdvanceFilter<InvoiceBatchFilterSchema>,
  handleSubmitAdvFilters: (v: AdvanceFilter<InvoiceBatchFilterSchema>) => void
) {
  return <InvoiceBatchCustomFilterWithRadios {...f} handleSubmitAdvFilters={handleSubmitAdvFilters} />;
}
